import {Modal, Form, Select, Input, DatePicker, TimePicker} from "antd";
import React, {useEffect} from "react";
import {Spacer} from "../../../../../../components/DesignSystem/Spacer/Spacer";
import {getFiltersByType} from "../../../../../../utils/filter.utils";
import moment from "moment";

const {Option} = Select;

export const FilterDialog = ({columns, editFilter, visible, onCancel, onOk}) => {

    const [form] = Form.useForm();
    const [operators, setOperators] = React.useState([]);
    const [selectedOperator, setSelectedOperator] = React.useState(null);
    const [selectedColumn, setSelectedColumn] = React.useState(null);

    const handleOk = () => {

        form.validateFields().then(values => {

            if (selectedOperator.inputType === 'date') {
                onOk({column: values.column, operator: values.operator, value: values.value.format('YYYY-MM-DD'), type: selectedColumn.type});
            } else if (selectedOperator.inputType === 'timestamp') {
                onOk({
                    column: values.column,
                    operator: values.operator,
                    value: values.value.format('YYYY-MM-DD HH:mm:ss'),
                    type: selectedColumn.type
                });
            } else if (selectedOperator.inputType === 'time') {
                onOk({column: values.column, operator: values.operator, value: values.value.format('HH:mm:ss'), type: selectedColumn.type});
            } else {
                onOk({...values, type: selectedColumn.type});
            }

        }).catch(error => {
            console.error("Validation failed:", error);
            // Handle validation errors if needed
        });

    }

    console.log("Edit filter:", editFilter);

    const handleColumnSelect = (value) => {
        const selectedColumn = columns.find(col => col.name === value);

        setSelectedOperator(null);
        setSelectedColumn(selectedColumn);

        setOperators(getFiltersByType(selectedColumn.type));

        form.setFieldValue("operator", null);
        form.setFieldValue("value", null);

    }

    const handleOperatorSelect = (value) => {
        const selectedOperator = operators.find(op => op.name === value);
        setSelectedOperator(selectedOperator);
    }

    useEffect(() => {
        if (editFilter !== undefined && columns !== undefined) {

            const selectedColumn = columns.find(col => col.name === editFilter.column);
            const operators = getFiltersByType(selectedColumn.type);

            setSelectedColumn(selectedColumn);
            setOperators(operators);

            setSelectedOperator(operators.find(op => op.name === editFilter.operator));

            let value = editFilter.value;

            if (editFilter.type === 'DATE' && editFilter.value) {
                value = moment(editFilter.value, 'YYYY-MM-DD');
            } else if (editFilter.type === 'TIMESTAMP' && editFilter.value) {
                value = moment(editFilter.value, 'YYYY-MM-DD HH:mm:ss');
            } else if (editFilter.type === 'TIME' && editFilter.value) {
                value = moment(editFilter.value, 'HH:mm:ss');
            }

            form.setFieldsValue({...editFilter, value: value});
        }
    }, [editFilter, columns]);

    return <Modal title="Filter data" open={visible} onCancel={onCancel}
                  centered
                  onOk={handleOk} okText={"Filter"} cancelText="Cancel">
        <Spacer/>

        <Form layout="vertical" form={form}>
            <Form.Item name="column" label="Column" required>
                <Select showSearch onSelect={handleColumnSelect}>
                    {columns.map((col, index) => (
                        <Option key={index} value={col.name}>{col.name} <span style={{fontSize: '10px'}}>({col.type})</span></Option>))}
                </Select>
            </Form.Item>
            <Form.Item name="operator" label="Operator" required>
                <Select showSearch onSelect={handleOperatorSelect}>
                    {operators.map((op, index) => (<Option key={index} value={op.name}>{op.name}</Option>))}
                </Select>
            </Form.Item>
            {selectedOperator && selectedOperator.inputType && (<Form.Item name="value" label="Value" rules={[{
                required: true, message: 'Please enter a value',
            }]}>
                {selectedOperator.inputType === 'number' && <Input type={"number"}/>}
                {selectedOperator.inputType === 'text' && <Input/>}
                {selectedOperator.inputType === 'date' && <DatePicker/>}
                {selectedOperator.inputType === 'time' && <TimePicker/>}
                {selectedOperator.inputType === 'timestamp' && <DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>}
            </Form.Item>)}
        </Form>
        <Spacer border={true}/>
    </Modal>

}